// Правила валідації (дзеркало server/utils/validators.js). Валідатори повертають
// '' коли все гаразд, або i18n-КЛЮЧ помилки (напр. 'validation.nameShort'),
// який компонент перекладає через t(). Сервер лишається джерелом істини.

export const PASSWORD_MIN = 8;

// i18n-ключ підказки формату телефону (для helperText за замовчуванням)
export const PHONE_RULE_KEY = 'validation.phoneRuleText';

// Довжина в байтах UTF-8 — bcrypt обрізає паролі > 72 байтів
const byteLength = (s) => new TextEncoder().encode(String(s)).length;

// Перелік вимог до паролю зі статусом виконання (для живого чекліста під полем).
// key -> i18n-ключ у passwordReq.*
export const passwordChecks = (value) => {
  const pw = value == null ? '' : String(value);
  return [
    { key: 'passwordReq.len', ok: pw.length >= PASSWORD_MIN },
    { key: 'passwordReq.upper', ok: /\p{Lu}/u.test(pw) },
    { key: 'passwordReq.lower', ok: /\p{Ll}/u.test(pw) },
    { key: 'passwordReq.digit', ok: /\d/.test(pw) },
  ];
};

export const validatePassword = (value) => {
  const pw = value == null ? '' : String(value);
  if (!pw) return 'validation.passwordRequired';
  if (pw.length < PASSWORD_MIN) return 'validation.passwordMin';
  if (byteLength(pw) > 72) return 'validation.passwordLong';
  if (!/\p{Ll}/u.test(pw)) return 'validation.passwordLower';
  if (!/\p{Lu}/u.test(pw)) return 'validation.passwordUpper';
  if (!/\d/.test(pw)) return 'validation.passwordDigit';
  return '';
};

export const validateName = (value) => {
  const name = value == null ? '' : String(value).trim();
  if (!name) return 'validation.nameRequired';
  if (name.length < 2) return 'validation.nameShort';
  if (name.length > 60) return 'validation.nameLong';
  if (!/\p{L}/u.test(name)) return 'validation.nameLetters';
  return '';
};

// Email опційний: порожній -> валідний (якщо не required)
export const validateEmail = (value, { required = false } = {}) => {
  const email = value == null ? '' : String(value).trim();
  if (!email) return required ? 'validation.emailRequired' : '';
  if (email.length > 254) return 'validation.emailLong';
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return 'validation.emailInvalid';
  return '';
};

// Звести введене до вигляду E.164-подібного
const toE164Like = (raw) => {
  let s = String(raw || '').trim().replace(/[^\d+]/g, '');
  if (s.startsWith('00')) s = '+' + s.slice(2);
  const plus = s.startsWith('+');
  return (plus ? '+' : '') + s.replace(/\+/g, '');
};

// Вимога формату E.164: обовʼязковий код країни (провідний '+'), 8–15 цифр.
export const validatePhone = (value) => {
  if (!value) return 'validation.phoneRequired';
  const s = toE164Like(value);
  if (!s.startsWith('+')) return 'validation.phoneCountryCode';
  const digits = s.replace(/\D/g, '');
  if (digits.length < 8 || digits.length > 15) return 'validation.phoneInvalid';
  return '';
};

export const validateServiceName = (value) => {
  const name = value == null ? '' : String(value).trim();
  if (!name) return 'validation.serviceNameRequired';
  if (name.length < 2) return 'validation.serviceNameShort';
  if (name.length > 80) return 'validation.serviceNameLong';
  return '';
};

export const validatePrice = (value) => {
  if (value === '' || value == null) return 'validation.priceRequired';
  const n = Number(value);
  if (Number.isNaN(n)) return 'validation.priceInvalid';
  if (n <= 0) return 'validation.pricePositive';
  if (n > 1000000) return 'validation.priceTooBig';
  if (Math.round(n * 100) !== n * 100) return 'validation.priceDecimals';
  return '';
};

export const validateDuration = (value) => {
  if (value === '' || value == null) return 'validation.durationRequired';
  const n = Number(value);
  if (Number.isNaN(n)) return 'validation.durationInvalid';
  if (!Number.isInteger(n)) return 'validation.durationInteger';
  if (n < 5) return 'validation.durationMin';
  if (n > 600) return 'validation.durationMax';
  return '';
};

// Зібрати ключі помилок полів: { field: value } -> { field: 'i18n-ключ' } (лише невалідні)
export const runValidators = (spec) => {
  const errors = {};
  for (const [field, err] of Object.entries(spec)) {
    if (err) errors[field] = err;
  }
  return errors;
};
